<template>
	<div class="topfixed-wrap">
		<div class="outer-width clearfix">
			<span class="icon-logoquan lf"></span>
			<a href="tel:4008396360"><span class="rf tel-zixun">咨询热线：400-839-6360</span></a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'topfixed',
		data() {
			return {

			}
		},
		mounted() {},
		methods: {}
	}
</script>

<style scoped>
	.topfixed-wrap {
		position: fixed;
		top: 0;
		height: .45rem;
		width: 100%;
		background: #030303;
		opacity: 0.9;
		/*background: rgba(0, 0, 0, .5) ;*/
		z-index: 3;
		/*box-shadow: 0 0 25px rgba(255, 255, 255, .3);
		-webkit-box-shadow: 0 0 25px rgba(255, 255, 255, .3);
		background: rgba(73, 73, 73, .15) !important;*/
	}
	
	.outer-width {
		width: 67%;
		margin: 0 auto
	}
	
	.tel-zixun {
		color: #fff;
		font-size: .24rem;
		padding-top: .055rem
	}
	
	.icon-logoquan::before {
		color: #fff;
		font-size: .32rem;
		margin-top: .055rem;
		display: inline-block
	}
</style>


// WEBPACK FOOTER //
// src/components/topfixed.vue